/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function CandidatesAndOfficialAgentsInformation() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="Candidates and Official Agents"
              description={
                <>
                  <h3>How to Become a Candidate</h3>
<br/>
                  <p>There are two types of candidates in Nova Scotia: those who are affiliated with a registered political party, and independents. If you are planning to run for election as an MLA representing a party, the party must first register with Nova Scotia&#39;s Chief Electoral Officer.</p>
                  <br/>
                  <h3>Candidate Registration</h3>
                  <br/>
                  <p>Candidates must register with Elections Nova Scotia if they receive a contribution or transfer, or if they have incurred an expense.&nbsp;
                    <a href="/files/CandidatesAndOfficialAgents/1-1_Application for Candidate Registration_PDF Fillable.pdf" target="_blank"> Form 1-1 </a>
                    must be completed and submitted for approval by the Chief Electoral Officer. &nbsp;If the candidate is endorsed by a registered political party, the Application for registration must also provide a statement of endorsement signed by the leader of that registered party. A Candidate may register at any time prior to a writ of election is issued.&nbsp;</p>
                    <br/>
                  <h3>FAQs</h3>
                  <br/>
                  <p>Candidates Frequently Asked Questions (FAQs): <a href="/files/CandidatesAndOfficialAgents/Candidate FAQs for ENS Website-Final for website.pdf" target="_blank"> link </a></p>
                  <br/>
                  <h3>Current Registered Candidates</h3>
                  <br/>
                  <p>The following candidate(s) are registered for pending elections in the electoral district indicated.<br />
                    <ul style={{ paddingLeft: "40px" }}>
                      <li>Peter MacIsaac, Independent Candidate – Inverness</li>
                      <li>Elizabeth Smith-McCrossin, Independent Candidate – Cumberland North</li>
                      <li>Lorne Fraser, Independent Candidate – Kings North</li>
                      <li>Julissa Stewart, Independent Candidate – Richmond</li>
                    </ul></p>
                    <br/>
                  <p>When a writ of election is issued, registered candidates must complete their nomination documents and have them accepted by the Returning Officer in the electoral district they wish to run, to become a nominated candidates and have their name added to the ballot.</p>

                  <br/>


                  <h3>The Candidate Nomination Process</h3>
                  <br/>
                  <p>Once an election is called, to become a formally nominated candidate, you must:</p>
                  <br/>
                  <ul style={{ paddingLeft: "40px" }}>
                    <li>file your completed nomination paper (<a href="/files/CandidatesAndOfficialAgents/105_Candidate%20Nomination_2.pdf">Form 105, Candidate Nomination </a>) with the Returning Officer in the electoral district in which you plan to run not later than 2:00 pm on Nomination Day, which is the 20th day before election day</li>
                    <li>pay a deposit of $200.</li>
                    <li>include a letter from the Party Leader endorsing your candidacy if you are running for a registered political party</li>
                    <li>have your Nomination Paper signed by at least five electors who would be qualified to vote for you. However, it is a good idea to have a few more signatures just in case there is a problem with someone&#39;s qualifications</li>
                    <li>appoint an Official Agent and an Auditor. Candidates must not handle their own finances.</li>
                  </ul>
                  <br/>
                  <p>Once you have done all that and the Returning Officer signs the receipt for your deposit on your Nomination Paper, you are considered &#39;officially nominated.&#39;</p>
                  <br/>
                  <p>What else does it take to become a candidate? You must</p>
                  <br/>
                  <ul style={{ paddingLeft: "40px" }}>
                    <li>be an eligible elector, i.e.,&nbsp;be at least 18 years of age on election day,&nbsp;be a Canadian citizen, and a resident of Nova Scotia for six months preceeding the issuance of the writ, and</li>
                    <li>not be disqualified to be a candidate or MLA under the <a href="https://nslegislature.ca/sites/default/files/legc/statutes/elections.pdf">Elections Act</a>, <a href="https://nslegislature.ca/sites/default/files/legc/statutes/house%20of%20assembly.pdf">House of Assembly Act</a>, or any other Provincial Act</li>
                  </ul>
                  <br/>
                  <h3>Nominated Candidates</h3>
                  <br/>
                  <strong>Nominated candidates require an auditor who is licensed to audit with <a href="https://cpans.ca/Main/Find-a-CPA/licenced-public-accountant-directory.aspx">CPA Nova Scotia.</a></strong><br /><br />
                  Please refer to the handbook “<a href="/files/CandidatesAndOfficialAgents/2024%20Information%20for%20Prospective%20Candidate%20OCT%2024.pdf">Information for Prospective Candidates</a>” for more details.

            </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default CandidatesAndOfficialAgentsInformation;
